import React from 'react';
import { ErrorMessage, useFormikContext } from 'formik';
import { Grid, Header, Message, Radio, Table } from 'semantic-ui-react';
import { IAttivitaAltoRischio, IEhs } from '@relab/alstom-ptw-shared';
import { DatePicker } from '../../../DatePicker';
import { TimePickerComponent } from '../../../TimePickerComponent';
import { BorderedDiv } from '../StyledEhsComponents';
import { TranslationComponent } from '../../../TranslationComponent';
import { useTranslation } from 'react-i18next';
import { EhsPhaseClosureForm } from './EhsPhaseClosureForm';
import { EhsPhaseClosureAttachment } from './EhsPhaseClosureAttachment';
import { InputWithoutEnter } from '../../../InputWithoutEnter';
import { SignatureField } from '../SignatureField';

export const closureInitialValues = (): Partial<IEhs> => ({
  fineLavoriDate: undefined,
  fineLavoriTime: undefined,
  approvazioneLavoriACaldo: undefined,
  closureType: undefined,
  ehsClosureFile: undefined,
  note: '',
  riconsegnaName: '',
  riconsegnaSign: null,
  prendeInConsegnaName: '',
  prendeInConsegnaSign: null,
  responsabileAltoRischioName: '',
  responsabileAltoRischioSign: null,
});

export const EhsPhaseClosure: React.FC = () => {
  const { values, setFieldValue } = useFormikContext<IEhs>();

  const { t } = useTranslation();

  return (
    <BorderedDiv>
      <Header>
        <TranslationComponent stringKey={'Approvazione Fine Lavoro/giornata'} />
      </Header>

      <Grid>
        <Grid.Row>
          <Grid.Column>
            <Header size={'small'}>
              <TranslationComponent stringKey={'Fine lavori'} />
            </Header>
          </Grid.Column>
        </Grid.Row>

        <Grid.Row columns={6}>
          <Grid.Column>
            <DatePicker label={t('Fine lavori')} name="fineLavoriDate" />
          </Grid.Column>

          <Grid.Column>
            <TimePickerComponent label={t('Hour')} name="fineLavoriTime" inputProps={{ showSecond: false }} />
          </Grid.Column>
        </Grid.Row>

        {values.attivitaAltoRischio.includes(IAttivitaAltoRischio.lavoriACaldo) && (
          <>
            <Grid.Row>
              <Grid.Column>
                <span>
                  <TranslationComponent stringKey={'lavoriACaldoApproval'} />
                </span>
              </Grid.Column>
            </Grid.Row>

            <Grid.Row>
              <Grid.Column>
                <Table>
                  <Table.Header>
                    <Table.Row>
                      <Table.HeaderCell>
                        <TranslationComponent stringKey={'lavoriACaldoInspector'} />
                      </Table.HeaderCell>

                      <Table.HeaderCell>
                        <TranslationComponent stringKey={'Date'} />
                      </Table.HeaderCell>

                      <Table.HeaderCell>
                        <TranslationComponent stringKey={'Hour'} />
                      </Table.HeaderCell>

                      <Table.HeaderCell>
                        <TranslationComponent stringKey={'Firma'} />
                      </Table.HeaderCell>
                    </Table.Row>
                  </Table.Header>

                  <Table.Body>
                    <Table.Row>
                      <Table.Cell width={5}>
                        <InputWithoutEnter name={'approvazioneLavoriACaldo.name'} />
                      </Table.Cell>

                      <Table.Cell width={2} verticalAlign={'top'}>
                        <DatePicker name={'approvazioneLavoriACaldo.date'} inputProps={{ openDirection: 'up' }} />
                      </Table.Cell>

                      <Table.Cell width={2} verticalAlign={'top'}>
                        <TimePickerComponent
                          name={'approvazioneLavoriACaldo.hour'}
                          inputProps={{ showSecond: false }}
                        />
                      </Table.Cell>

                      <Table.Cell width={3}>
                        <SignatureField name={'approvazioneLavoriACaldo.sign'} />
                      </Table.Cell>
                    </Table.Row>
                  </Table.Body>
                </Table>
              </Grid.Column>
            </Grid.Row>
          </>
        )}

        <Grid.Row columns={1}>
          <Grid.Column>
            <Radio
              label={t('Compilazione form')}
              name="closureType"
              value="form"
              checked={values.closureType === 'form'}
              onChange={(event, data) => setFieldValue('closureType', data.value)}
            />

            <br />

            <Radio
              label={t('Allega PDF')}
              name="closureType"
              value="attachment"
              checked={values.closureType === 'attachment'}
              onChange={(event, data) => setFieldValue('closureType', data.value)}
            />
          </Grid.Column>

          <br />

          <ErrorMessage name="closureType">
            {(msg) => <Message error visible content={msg} style={{ margin: '0 15px' }} />}
          </ErrorMessage>
        </Grid.Row>

        {values.closureType === 'attachment' ? <EhsPhaseClosureAttachment /> : <EhsPhaseClosureForm />}
      </Grid>
    </BorderedDiv>
  );
};
